export default "__VITE_ASSET__DZzKhBFV__"